export const medicalPlansConstants = {
  GETMEDICALPLANS_REQUEST: 'GETMEDICALPLANS_REQUEST',
  GETMEDICALPLANS_SUCCESS: 'GETMEDICALPLANS_SUCCESS',
  GETMEDICALPLANS_FAILURE: 'GETMEDICALPLANS_FAILURE',
};
